import { collections } from "@/mocks/home";

export default function CollectionSection() {
  return (
    <section id="collections" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-label tracking-wide text-primary-600">
              <i className="ri-stack-line" />
              故事合集
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              主线之外，还有这些短篇
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              每个合集都可以单独进入，按自己的节奏挑一篇开始。
            </p>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-label text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            全部合集
            <i className="ri-arrow-right-line" />
          </button>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5 lg:gap-5">
          {collections.map((col) => (
            <button
              key={col.title}
              type="button"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 text-left transition-colors hover:border-primary-300"
            >
              <div className="relative h-56 w-full overflow-hidden md:h-64 lg:h-72">
                <img
                  src={col.cover}
                  alt={`${col.title}故事合集封面`}
                  title={`善良的女秘书 ${col.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-label text-foreground-700">
                  {col.count}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                  {col.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-6 text-foreground-600">{col.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-label text-primary-600">
                  进入合集
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}